module.exports = __webpack_public_path__ + "static/img/onozuka_03.9c2e436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_03.jpg
// module id = OqF5
// module chunks = 0